import { Application } from "@hotwired/stimulus";
import ConstructorController from "../controllers/constructor_controller.js";
import CookieConsentController from "../controllers/cookie_consent_controller.js";

const application = Application.start();
application.register("constructor", ConstructorController);
application.register("cookie-consent", CookieConsentController);
